module.exports = __webpack_public_path__ + "img/Apica.e6a6d2f8.png";